import React, { useEffect, useState } from "react";
import { ColumnValueRendererProps } from "../table.data.interface";
import { Chips } from "@vibe/core";
import { Tooltip } from "@vibe/core";
import { MondayApiQueryInstance } from "@services/monday/monday-service-ts";
import logger from "lib/logger";

const DropdownColumn = ({
  itemIds,
  columnData,
  isPreview,
  otherBoardsValues,
}: ColumnValueRendererProps) => {
  const [dropdownLabels, setDropdownLabels] = useState<{ label: string; id: string }[]>([]);

  const fetchDropdownLabels = async (itemId: number, columnId: string) => {
    try {
      const response = await MondayApiQueryInstance.getDropdownLabels(itemId, columnId);

      setDropdownLabels(response);
    } catch (error: any) {
      logger.error("Error fetching dropdown labels", error.message);
    }
  };
  useEffect(() => {
    if (columnData.columnId && itemIds?.[0]) {
      fetchDropdownLabels(itemIds?.[0], columnData.columnId);
    }
  }, [columnData.columnId, columnData, itemIds]);

  if (
    columnData.value === "Empty Column" ||
    (!columnData.text && isPreview) ||
    (!columnData?.values && otherBoardsValues)
  ) {
    return null;
  }

  return (
    <div className="flex">
      <Tooltip
        content={
          <div className="flex flex-col gap-1">
            {dropdownLabels.map((value) => (
              <div key={value.id} className="flex">
                {value.label}
              </div>
            ))}
          </div>
        }
      >
        {dropdownLabels.map((value) => (
          <Chips readOnly={true} className="first:!ml-0" key={value.id} label={value.label} />
        ))}
      </Tooltip>
    </div>
  );
};

export default DropdownColumn;
